import { createStructuredSelector } from "reselect";
import {
    ATC_LIST,
    ATC_LIST_SUCCESS,
    ATC_LIST_ERROR
} from "../actions";

export const NAME = 'atc';

export const AtcList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: ATC_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const AtcListSuccess = (data) => ({
    type: ATC_LIST_SUCCESS,
    payload: data
});

export const AtcListError = (error) => ({
    type: ATC_LIST_ERROR,
    payload: error
});

const atc = (state) => state[NAME];

export const AtcSelector = createStructuredSelector({
    atc
})
